import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LoginForm, LoginFormProps } from 'record-it-components/form/LoginForm/LoginForm';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { UrlUtils } from 'record-it-utils/utils/UrlUtils/UrlUtils';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
import { useLoginFunction } from '../../../hooks/authentication/useLoginFunction/useLoginFunction';
export type LoginPageProps = Record<string, never>;
export const LoginPage: FunctionComponent<LoginPageProps> = () => {
  const $ = _c(9);
  const [errorMessage, setErrorMessage] = useState();
  const {
    t
  } = useTranslation();
  const navigate = useNavigate();
  let t0;
  if ($[0] !== t) {
    t0 = {
      onError: () => setErrorMessage(t("components.page.LoginPage.loginFailed"))
    };
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const login = useLoginFunction(t0);
  const handleCreateAccount = useEventCallback(_temp);
  let t1;
  if ($[2] !== navigate) {
    t1 = email => {
      navigate({
        pathname: RoutePaths.forgotPassword(),
        search: UrlUtils.getSearchStringFromMap({
          email
        })
      });
    };
    $[2] = navigate;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleForgotPassword = useEventCallback(t1);
  let t2;
  if ($[4] !== errorMessage || $[5] !== handleCreateAccount || $[6] !== handleForgotPassword || $[7] !== login) {
    t2 = <LoginForm errorMessage={errorMessage} login={login} onCreateAccount={handleCreateAccount} onForgotPassword={handleForgotPassword} />;
    $[4] = errorMessage;
    $[5] = handleCreateAccount;
    $[6] = handleForgotPassword;
    $[7] = login;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
function _temp() {}